<template>
  <div class="app-section-template-default">

    <slot/>

  </div>
</template>

<script>
export default {
  name: 'AppSectionTemplateDefault',
}
</script>

<style scoped lang="scss">
  .app-section-template-default {
    width: 100%;
    margin-bottom: 60px;
  }
</style>
